import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthFooter } from './AuthFooter';

interface LegalPageLayoutProps {
  title: string;
  children: ReactNode;
}

export const LegalPageLayout = ({ title, children }: LegalPageLayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="bg-white border-b border-gray-200 py-4 px-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/login" className="text-primary font-display text-xl">
            ADN Conformité
          </Link>
          <Link to="/login" className="text-sm text-primary hover:underline">
            {t('footer.back_to_login')}
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 py-12">
        <h1 className="text-3xl font-display text-primary mb-8">{title}</h1>
        {children}
      </main>
      <AuthFooter />
    </div>
  );
};
